import { useMemo } from "react";
import { DandelionSeed } from "@/components/DandelionSeed";

/**
 * Emits dandelion seeds drifting away from the dandelion focal point
 * (right-center of the Hero). Pure CSS animation — very calm.
 */
export default function HeroSeeds({ count = 22 }) {
  const seeds = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        // Emission point: right-center of the hero (where the dandelion is)
        // Vary it slightly for a natural cluster
        const top = 38 + Math.random() * 28;        // 38–66% (right of center vertically)
        const left = 60 + Math.random() * 22;       // 60–82% (right side)

        // Seeds drift mostly to the left and slightly up, with some variance
        const tx = -(180 + Math.random() * 520);   // -180 to -700 px
        const ty = -60 + (Math.random() - 0.5) * 280; // mostly slight up, can drift down
        const rot = (Math.random() - 0.5) * 70;

        const dur = 14 + Math.random() * 16;        // 14–30s
        const delay = -Math.random() * dur;         // negative so seeds are already mid-flight
        const size = 14 + Math.random() * 18;       // 14–32 px
        const op = 0.5 + Math.random() * 0.35;      // 0.5–0.85

        return { i, top, left, tx, ty, rot, dur, delay, size, op };
      }),
    [count]
  );

  return (
    <div
      aria-hidden="true"
      className="absolute inset-0 pointer-events-none overflow-hidden"
    >
      {seeds.map((s) => (
        <span
          key={s.i}
          className="hero-seed"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            color: "rgba(255, 255, 255, 0.85)",
            filter: "drop-shadow(0 0 2px rgba(140, 160, 180, 0.25))",
            "--hs-tx": `${s.tx}px`,
            "--hs-ty": `${s.ty}px`,
            "--hs-rot": `${s.rot}deg`,
            "--hs-dur": `${s.dur}s`,
            "--hs-delay": `${s.delay}s`,
            "--hs-op": s.op,
          }}
        >
          <DandelionSeed size={s.size} />
        </span>
      ))}
    </div>
  );
}
